import { render, staticRenderFns } from "./TsBranchFilter.vue?vue&type=template&id=18d2672c&scoped=true"
import script from "./TsBranchFilter.vue?vue&type=script&lang=js"
export * from "./TsBranchFilter.vue?vue&type=script&lang=js"
import style0 from "./TsBranchFilter.vue?vue&type=style&index=0&id=18d2672c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d2672c",
  null
  
)

export default component.exports